import React from "react";
import gql from "graphql-tag";
import { navigate } from "@reach/router";
import { Breakpoint } from "react-socks";
import styled from "@emotion/styled";
import { RailsUrl } from "@services";
import { Box, H3, Image, Flex, Text, FontAwesome, TouchableOpacity } from "@atoms";
import { BrandOfferSingleFragment } from "./__generated__/BrandOfferSingleFragment";

// == Types ================================================================

interface IProps {
  brand: BrandOfferSingleFragment;
  isHome?: boolean;
}

// == Constants ============================================================
const FRAGMENTS = {
  fields: gql`
    fragment BrandOfferSingleFragment on Brand {
      id
      name
      logoImage
      logoBackgroundColor
      invertedLogoImage
      maxGiveLink {
        id
        giveSentence
      }
    }
  `,
};

const DEFAULT_PROPS = {
  imagePadding: 15,
  imageWidth: 180,
  imageHeight: 135,
};
// == Component ============================================================

const BrandOfferSingle = ({
  brand,
  imageWidth,
  imageHeight,
  imagePadding,
  isHome,
  ...rest
}: IProps) => {
  const { maxGiveLink: link } = brand;
  if (!link) return null;
  const onTouch = () => {
    const brandRoute = RailsUrl.brandModalUrl({ id: brand.id });
    navigate(brandRoute, { state: { brandRoute } });
  };
  const brandLogo = brand.invertedLogoImage ? brand.invertedLogoImage : brand.logoImage;
  const brandLogoBg = brand.invertedLogoImage ? brand.logoBackgroundColor : "#FFFFFF";

  // isHome to be changed to variat="mini"
  return (
    <TouchableOpacity containerProps={{ style: { width: "100%" } }} onTouch={onTouch}>
      <Flex alignItems="center" border="silver" p={2} {...rest}>
        <Box maxWidth="100px" mr={3}>
          <Image
            alt={brand.name}
            src={`${brandLogo}&w=${imageWidth}&h=${imageHeight}&fit=fill&bg=${brandLogoBg.slice(
              1
            )}&pad=${imagePadding}`}
          />
        </Box>
        {isHome ? (
          <Box>
            <Text display="block" fontSize={[1]} fontWeight="bold" lineHeight="title" mb={1}>
              {brand.name}
            </Text>
            <H3>{link.giveSentence}</H3>

            <Flex alignItems="center" justifyContent="flex-start">
              <Text color="primary" fontWeight="bold" mr={1}>
                Shop Now
              </Text>
              <Text color="primary">
                <FontAwesome icon="chevron-right" />
              </Text>
            </Flex>
          </Box>
        ) : (
          <>
            <Box>
              <Text fontSize={[1, 3]} fontWeight="bold">
                {brand.name}
              </Text>
              <H3>{link.giveSentence}</H3>

              <Breakpoint xsmall>
                <Flex alignItems="center" justifyContent="flex-start">
                  <Text color="primary" fontWeight="bold" mr={1}>
                    Shop Now
                  </Text>
                  <Text color="primary">
                    <FontAwesome icon="chevron-right" />
                  </Text>
                </Flex>
              </Breakpoint>
            </Box>

            <EShopNowColumnBreakpoint small up>
              <Flex alignItems="center" flex={1} justifyContent="flex-end">
                <Text color="primary" fontSize={4} fontWeight="bold" mr={2}>
                  Shop Now
                </Text>
                <Text color="primary">
                  <FontAwesome color="primary" icon="chevron-right" />
                </Text>
              </Flex>
            </EShopNowColumnBreakpoint>
          </>
        )}
      </Flex>
    </TouchableOpacity>
  );
};

BrandOfferSingle.defaultProps = DEFAULT_PROPS;
BrandOfferSingle.fragments = FRAGMENTS;
export default BrandOfferSingle;

// == Styles ===============================================================

const EShopNowColumnBreakpoint = styled(Breakpoint)`
  flex: 1;
`;
